import StockTable from './StockTable'

export default StockTable
